import { PageHeader } from '@/components/PageHeader'

type SentQuoteRequestsHeaderProps = { emails?: string[] | null }

export const SentQuoteRequestsHeader = ({
  emails,
}: SentQuoteRequestsHeaderProps) => {
  return (
    <>
      <PageHeader
        title="We sent a quote request to the following contacts:"
        icon="check-circle"
        iconClass="text-fv-green-500 text-xl"
      ></PageHeader>

      <div className="mb-12 overflow-auto flex-1">
        <p className="mb-0">{emails?.join(', ')}</p>
      </div>
    </>
  )
}
